import React, { useState } from 'react';
import './Login.css';
import Logo from '../../assets/images/logo.svg';
import DutaLogo from '../../assets/images/pt_duta_logo.png';
import { loginPost } from '../../Api';

function Login() {
  sessionStorage.removeItem('canAccessReset');
  sessionStorage.removeItem('canAccessValidate');

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await loginPost(email, password);

      // Save the token and user data in localStorage
      localStorage.setItem('token', data.token);
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('userId', data.user.id);
      localStorage.setItem('user', JSON.stringify(data.user));

      // Save the login timestamp (current time) in localStorage
      const currentTime = new Date().getTime(); // Get the current time in milliseconds
      localStorage.setItem('loginTime', currentTime);

      // Redirect the user to the home page
      window.location.href = '/';
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        const backendError =
          err.response.data.errors.message?.[0] || 'Invalid email or password';
        setError(backendError);
      } else {
        setError('Invalid email or password');
      }
    }
  };

  return (
    <div className="login-page">
    <div className="logo_wrap">
    <img src={Logo} alt="Jasa Indonesia Perdana Logo" className="logo" />
    <img src={DutaLogo} alt="Duta Indonesia Perdana Logo" className="dutalogo" />
    </div>
     
      <h1>Login</h1>
      <form className="login-form" onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <div className="password-container">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <span
            className="password-toggle-icon"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="#6E6BF0"
                width="20"
                height="20"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="#6E6BF0"
                width="20"
                height="20"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            )}
          </span>
        </div>
        <button type="submit">Enter</button>
      </form>
      {error && <p className="error">{error}</p>}
      <div className="links">
        <span>Forgot your password?</span>
        <a href="/forgot-password"> Click Here</a>
      </div>
      <p>
        By continuing, you agree to our <a href="/terms">Terms</a> &{' '}
        <a href="/privacy-policy">Privacy Policy</a>.
      </p>
    </div>
  );
}

export default Login;
